import styled, { ThemeProps } from 'styled-components';
import { ITheme } from 'providers/ThemeProvider/interfaces/ITheme';

export const ModalContent = styled.div`
  padding: ${({ theme }: ThemeProps<ITheme>): string =>
    `${theme.spacing.spacingSizes.sm} ${theme.spacing.spacingSizes.sm}`};
`;
